import styled from 'styled-components';

export const Container = styled.ul`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  li {
    display: flex;
    justify-content: left;
    align-items: center;
    color: #444;

    & + li {
      margin-left: 15px;
    }
  }    
  `;

export const ImageInfo = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;  

  button {
    border: 0;
    background: transparent;
    color: #e57878;
    margin-top: 5px;
    cursor: pointer;
  }
`;

export const Preview = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 5px;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50% 50%;
`;